import React, { useState } from "react";
import { Button, Col, Input, Modal, ModalBody, ModalHeader } from "reactstrap";
import { toast } from "react-toastify";
import { APIClient } from "../../helpers/api_helper";

const apiClient = new APIClient();

const ModalVoucher = ({
  show,
  setModalVoucher,
  setLoading,
  setFetch
}) => {
  const [codigo, setCodigo] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const usarVoucher = async (event) => {
    event.preventDefault();
    
    if (!codigo.trim()) {
      toast.error("Por favor, insira um código de voucher");
      return;
    }

    setIsLoading(true);
    
    const response = await apiClient.post("/usar-voucher", {
      codigo: codigo.trim()
    });

    if (response.sucesso) {
      toast.success(response.mensagem);
      handleClose();
      if (setLoading) setLoading(true);
      if (setFetch) setFetch(true);
    } else {
      toast.error(response.mensagem);
      console.log(response.dados);
    }
    
    setIsLoading(false);
  };

  const handleClose = () => {
    setCodigo("");
    setModalVoucher(false);
  };

  return (
    <Modal
      isOpen={show}
      toggle={handleClose}
    >
      <ModalHeader
        className="modal-title"
        toggle={handleClose}
      >
        Aplicar Voucher
      </ModalHeader>
      <ModalBody>
        <form onSubmit={usarVoucher}>
          <div className="row g-3">
            <Col lg={12}>
              <div>
                <label htmlFor="codigo" className="form-label">
                  Código do Voucher
                </label>
                <Input
                  type="text"
                  className="form-control"
                  id="codigo"
                  placeholder="Digite o código do voucher"
                  value={codigo}
                  onChange={(e) => setCodigo(e.target.value)}
                  disabled={isLoading}
                />
                <small className="form-text text-muted mt-1">
                  Insira o código do voucher para aplicar o benefício
                </small>
              </div>
            </Col>

            <Col lg={12}>
              <div className="hstack gap-2 justify-content-end">
                <Button 
                  color="light" 
                  type="button"
                  onClick={handleClose}
                  disabled={isLoading}
                >
                  Cancelar
                </Button>
                <Button
                  color="primary"
                  type="submit"
                  disabled={isLoading || !codigo.trim()}
                >
                  {isLoading ? "Aplicando..." : "Aplicar Voucher"}
                </Button>
              </div>
            </Col>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default ModalVoucher; 